import React from 'react';
import { TrendingUp, PieChart, Target, Shield } from 'lucide-react';
import { investmentFeatures, investmentStats } from '../data/mock';
import { Button } from './ui/button';

const iconMap = {
  TrendingUp: TrendingUp,
  PieChart: PieChart,
  Target: Target,
  Shield: Shield
};

const Investments = () => {
  return (
    <section id="investments" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="mb-16">
          <h2 className="text-sm font-semibold text-blue-600 mb-4 uppercase tracking-wide">Investment Services</h2>
          <h3 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Build Wealth Through Strategic Real Estate Investments
          </h3>
          <p className="text-lg text-gray-600 max-w-3xl">
            We specialize in identifying, acquiring, and managing high-performance
            real estate assets. With a decade plus of market expertise, we help clients build diversified
            portfolios that deliver consistent returns.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Features List */}
          <div className="space-y-6">
            {investmentFeatures.map((feature, index) => {
              const Icon = iconMap[feature.icon];
              return (
                <div
                  key={index}
                  className="border-l-4 border-blue-600 pl-6 py-4 hover:bg-gray-50 transition-all duration-300 rounded-r"
                >
                  <div className="flex items-start space-x-4">
                    <div className="bg-blue-50 p-3 rounded-full">
                      <Icon className="w-6 h-6 text-blue-600" />
                    </div>
                    <div>
                      <h4 className="text-xl font-semibold text-gray-900 mb-2">{feature.title}</h4>
                      <p className="text-gray-600">{feature.description}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          {/* Image with Stat Overlay */}
          <div className="relative">
            <img
              src={investmentStats[0].image}
              alt="Commercial Investment Property"
              className="w-full h-[500px] object-cover rounded-2xl shadow-xl"
            />
            <div className="absolute bottom-8 left-8 bg-blue-600 text-white p-6 rounded-xl shadow-2xl">
              <div className="text-sm font-medium mb-2">{investmentStats[0].label}</div>
              <div className="text-5xl font-bold">{investmentStats[0].value}</div>
            </div>
          </div>
        </div>

        {/* Call to Action Button */}
        <div className="text-center mt-12">
          <Button
            size="lg"
            onClick={() => {
              const element = document.getElementById('contact');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            className="bg-blue-600 hover:bg-blue-700 text-white px-12 py-6 text-lg"
          >
            Examine Current Opportunities
          </Button>
        </div>
      </div>
    </section>
  );
};

export default Investments;